import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileDeleteMutationAtom = createMutationAtomFactory(
  'trade.fileDelete',
  (params: { fileId: string }) => ({
    tradeFileDelete: {
      __args: { fileId: params.fileId },
    },
  }),
  { showLoadingOverlay: false },
);
